module.exports = __webpack_public_path__ + "static/media/fazanlogo.5e50b0cf.png";